import React, { useState } from 'react';
import axios from 'axios';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';

const publicApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/auth` });

const ResetPassword = ({ token }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await publicApi.post('/reset-password', { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'This reset link is invalid or has expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-shell" data-testid="reset-password-screen">
        <div className="login-bg-grid" />
        <div className="login-card">
          <div className="login-brand">LegacyCRM</div>
          <div className="login-error" data-testid="reset-password-missing-token">
            This reset link is missing its token. Please use the link from your email, or request a new one.
          </div>
          <a className="login-submit" style={{ display: 'block', textAlign: 'center', textDecoration: 'none', marginTop: 10 }} href="/login">Back to login</a>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="login-shell" data-testid="reset-password-screen">
        <div className="login-bg-grid" />
        <div className="login-card" data-testid="reset-password-success">
          <div className="login-brand">LegacyCRM</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#64cb13', margin: '14px 0 4px', fontSize: 14, fontWeight: 600 }}>
            <CheckCircle2 size={18} /> Password updated
          </div>
          <div className="login-tag" style={{ marginBottom: 16 }}>You can now sign in with your new password.</div>
          <a className="login-submit" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }} href="/login" data-testid="reset-password-go-login">Back to login</a>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell" data-testid="reset-password-screen">
      <div className="login-bg-grid" />
      <form className="login-card" onSubmit={submit} data-testid="reset-password-form" noValidate>
        <div className="login-brand">LegacyCRM</div>
        <div className="login-tag">Choose a new password</div>

        <label className="login-label"><Lock size={12} className="login-label-ico" /><span>New password</span></label>
        <input
          type="password" value={password} onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password" required autoFocus minLength={8}
          className="login-input" data-testid="reset-password-input" placeholder="At least 8 characters"
        />

        <label className="login-label"><Lock size={12} className="login-label-ico" /><span>Confirm password</span></label>
        <input
          type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password" required minLength={8}
          className="login-input" data-testid="reset-password-confirm-input" placeholder="Re-enter password"
        />

        {error && <div className="login-error" data-testid="reset-password-error">{error}</div>}

        <button type="submit" disabled={loading} className="login-submit" data-testid="reset-password-submit">
          {loading ? <><Loader2 size={13} className="spin" />Updating…</> : 'Set new password'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
